var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',[_c('module',[_c('div',{staticClass:"flex-column flex-center",staticStyle:{"height":"100%"}},[_vm._v("404")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }